// extracted by mini-css-extract-plugin
export default {"title":"styles_title__3qkQH","txt":"styles_txt__TnYoS","col":"styles_col__xuO2x"};